module.exports = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, stack2, functionType="function", escapeExpression=this.escapeExpression, self=this, helperMissing=helpers.helperMissing;

function program1(depth0,data,depth1) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\n                    ";
  options = {hash:{},inverse:self.noop,fn:self.programWithDepth(2, program2, data, depth1),data:data};
  stack2 = ((stack1 = helpers.filterLinks || depth0.filterLinks),stack1 ? stack1.call(depth0, depth0['hotspot type'], options) : helperMissing.call(depth0, "filterLinks", depth0['hotspot type'], options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n                ";
  return buffer;
  }
function program2(depth0,data,depth2) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\n                        <li>\n                            ";
  options = {hash:{},inverse:self.noop,fn:self.programWithDepth(3, program3, data, depth2),data:data};
  stack2 = ((stack1 = helpers.getProductInfo || depth0.getProductInfo),stack1 ? stack1.call(depth0, depth0, options) : helperMissing.call(depth0, "getProductInfo", depth0, options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n                            <!--<img src=\""
    + escapeExpression(((stack1 = ((stack1 = depth0.product_info),stack1 == null || stack1 === false ? stack1 : stack1.image)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" alt=\"\" width=\"40\" class=\"product-photo\" data-product=\""
    + escapeExpression(((stack1 = ((stack1 = depth2.page1),stack1 == null || stack1 === false ? stack1 : stack1.page_number)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + ",";
  if (stack2 = helpers.link_to_product) { stack2 = stack2.call(depth0, {hash:{},data:data}); }
  else { stack2 = depth0.link_to_product; stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2; }
  buffer += escapeExpression(stack2)
    + "\"/>-->\n                            <!--<strong>";
  options = {hash:{},data:data};
  buffer += escapeExpression(((stack1 = helpers.getHeader || depth0.getHeader),stack1 ? stack1.call(depth0, ((stack1 = depth0.product_info),stack1 == null || stack1 === false ? stack1 : stack1.title), options) : helperMissing.call(depth0, "getHeader", ((stack1 = depth0.product_info),stack1 == null || stack1 === false ? stack1 : stack1.title), options)))
    + "</strong>-->\n                        </li>\n                    ";
  return buffer;
  }
function program3(depth0,data,depth3) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\n                                ";
  stack1 = helpers.unless.call(depth0, depth0.isNoDesc, {hash:{},inverse:self.noop,fn:self.program(4, program4, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                                <img src=\"";
  options = {hash:{},data:data};
  buffer += escapeExpression(((stack1 = helpers.constructImage || depth0.constructImage),stack1 ? stack1.call(depth0, depth0.imageref, options) : helperMissing.call(depth0, "constructImage", depth0.imageref, options)))
    + "\" alt=\"\" width=\"40\" class=\"product-photo\" data-product=\""
    + escapeExpression(((stack1 = ((stack1 = depth3.page1),stack1 == null || stack1 === false ? stack1 : stack1.page_number)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + ",";
  if (stack2 = helpers.link_to_product) { stack2 = stack2.call(depth0, {hash:{},data:data}); }
  else { stack2 = depth0.link_to_product; stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2; }
  buffer += escapeExpression(stack2)
    + "\"/>\n                                <strong>";
  if (stack2 = helpers.title) { stack2 = stack2.call(depth0, {hash:{},data:data}); }
  else { stack2 = depth0.title; stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2; }
  buffer += escapeExpression(stack2)
    + "</strong>\n                            ";
  return buffer;
  }
function program4(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "<a class=\"btn-add-to-cart\" href=\"#\" title=\"";
  if (stack1 = helpers.link_to_product) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = depth0.link_to_product; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "\">add to cart</a>";
  return buffer;
  }

function program6(depth0,data,depth1) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\n                    ";
  options = {hash:{},inverse:self.noop,fn:self.programWithDepth(7, program7, data, depth1),data:data};
  stack2 = ((stack1 = helpers.filterLinks || depth0.filterLinks),stack1 ? stack1.call(depth0, depth0['hotspot type'], options) : helperMissing.call(depth0, "filterLinks", depth0['hotspot type'], options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n                ";
  return buffer;
  }
function program7(depth0,data,depth2) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\n                        <li>\n                            ";
  options = {hash:{},inverse:self.noop,fn:self.programWithDepth(8, program8, data, depth2),data:data};
  stack2 = ((stack1 = helpers.getProductInfo || depth0.getProductInfo),stack1 ? stack1.call(depth0, depth0, options) : helperMissing.call(depth0, "getProductInfo", depth0, options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n                            <!--<img src=\""
    + escapeExpression(((stack1 = ((stack1 = depth0.product_info),stack1 == null || stack1 === false ? stack1 : stack1.image)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" alt=\"\" width=\"40\" class=\"product-photo\" data-product=\""
    + escapeExpression(((stack1 = ((stack1 = depth2.page2),stack1 == null || stack1 === false ? stack1 : stack1.page_number)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + ",";
  if (stack2 = helpers.link_to_product) { stack2 = stack2.call(depth0, {hash:{},data:data}); }
  else { stack2 = depth0.link_to_product; stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2; }
  buffer += escapeExpression(stack2)
    + "\"/>-->\n                            <!--<strong>";
  options = {hash:{},data:data};
  buffer += escapeExpression(((stack1 = helpers.getHeader || depth0.getHeader),stack1 ? stack1.call(depth0, ((stack1 = depth0.product_info),stack1 == null || stack1 === false ? stack1 : stack1.title), options) : helperMissing.call(depth0, "getHeader", ((stack1 = depth0.product_info),stack1 == null || stack1 === false ? stack1 : stack1.title), options)))
    + "</strong>-->\n                        </li>\n                    ";
  return buffer;
  }
function program8(depth0,data,depth3) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\n                                ";
  stack1 = helpers.unless.call(depth0, depth0.isNoDesc, {hash:{},inverse:self.noop,fn:self.program(4, program4, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                                <img src=\"";
  options = {hash:{},data:data};
  buffer += escapeExpression(((stack1 = helpers.constructImage || depth0.constructImage),stack1 ? stack1.call(depth0, depth0.imageref, options) : helperMissing.call(depth0, "constructImage", depth0.imageref, options)))
    + "\" alt=\"\" width=\"40\" class=\"product-photo\" data-product=\""
    + escapeExpression(((stack1 = ((stack1 = depth3.page2),stack1 == null || stack1 === false ? stack1 : stack1.page_number)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + ",";
  if (stack2 = helpers.link_to_product) { stack2 = stack2.call(depth0, {hash:{},data:data}); }
  else { stack2 = depth0.link_to_product; stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2; }
  buffer += escapeExpression(stack2)
    + "\"/>\n                                <strong>";
  if (stack2 = helpers.title) { stack2 = stack2.call(depth0, {hash:{},data:data}); }
  else { stack2 = depth0.title; stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2; }
  buffer += escapeExpression(stack2)
    + "</strong>\n                            ";
  return buffer;
  }

  buffer += "<div class=\"popup-inner\">\n    <a href=\"#\" class=\"btn-view\">View</a>\n    <h3>Pages "
    + escapeExpression(((stack1 = ((stack1 = depth0.page1),stack1 == null || stack1 === false ? stack1 : stack1.page)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + " and "
    + escapeExpression(((stack1 = ((stack1 = depth0.page2),stack1 == null || stack1 === false ? stack1 : stack1.page)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</h3>\n\n    <div class=\"column-holder\">\n        <div class=\"col1\">\n            <ul class=\"product-list\">\n                ";
  stack2 = helpers.each.call(depth0, ((stack1 = depth0.page1),stack1 == null || stack1 === false ? stack1 : stack1.hotspots), {hash:{},inverse:self.noop,fn:self.programWithDepth(1, program1, data, depth0),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n            </ul>\n        </div>\n        <div class=\"col2\">\n            <ul class=\"product-list\">\n                ";
  stack2 = helpers.each.call(depth0, ((stack1 = depth0.page2),stack1 == null || stack1 === false ? stack1 : stack1.hotspots), {hash:{},inverse:self.noop,fn:self.programWithDepth(6, program6, data, depth0),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n            </ul>\n        </div>\n    </div>\n\n</div>\n";
  return buffer;
  });